import React from 'react';
import {ChoiceQuestionDto, UserRole} from '../../scaffold';
import MarkdownRender from '../Shared/MarkdownRender';
import {IQuestionDisplayProps} from './QuestionDisplay';
import useAuth from '../../utils/AuthContext';
import {useTabLayout} from '../../TabLayout/TabLayoutProvider';

export default function CodingQuestionDisplay(props: IQuestionDisplayProps<ChoiceQuestionDto>) {
  const {question} = props;
  const labels = 'ABCDEFGHIJKLMN';
  const auth = useAuth();
  const tabLayout = useTabLayout();
  const isStudent = auth.currentUser?.role === UserRole.学生;
  return (
    <div>
      <MarkdownRender className={'smallMarkdown'} md={'**[' + (isStudent ? '编程关' : '编程题') + ']** ' + question.topic || ''} />
      {isStudent && <a onClick={() => tabLayout.goTo('/app/codingQuestion/' + props.question.id)}>前往查看关卡</a>}
      {!isStudent && <a onClick={() => tabLayout.goTo('/manage/codingQuestion/' + props.question.id)}>前往查看题目</a>}
    </div>
  );
}
